<section id="content">

  <div class="row">
    <div class="col-md-12 col-xs-12 table-cont">
      <div class="form-group">
        <div class="card">
          <div class="card-title">
            Customer Orders
            <i class="collapse-icon fa"></i>
          </div>

          <div class="card customer-select">
            <div class="card-header">
              <label for="customer">Choose a Customer</label>
             <p-dropdown id="customer" name="customer" [options]="customerOptions" placeholder="Select Customer"
              optionLabel="customerName" optionValue="id" class="full-width" [(ngModel)]="selectedCustomer"
              [virtualScroll]="true" [lazy]="true" [filter]="true" [virtualScrollItemSize]="38"
              filterBy="customerNumber,customerName" [showClear]="true" (onLazyLoad)="loadCustomersLazy($event)"
              (onChange)="onCustomerChange()">
    <ng-template let-option pTemplate="item">
      <span id="{{ option.id }}">{{ option.customerNumber + ' - ' + option.customerName }}</span>
    </ng-template>
  </p-dropdown>

  <!-- Heading showing selected customer -->
  
            </div>
          </div>

          <div class="cont group">
            <div class="collapse-title">
              <h5>Orders Items of {{ selectedCustomerName }}</h5>
            </div>

            <div class="table-responsive">
              <p-table #codt [rows]="10" [rowsPerPageOptions]="[10, 25, 50]" [scrollable]="true" scrollHeight="500px"
                [rowHover]="true" [showCurrentPageReport]="true" [paginator]="true" class="table"
                [autoLayout]="true" styleClass="ui-table-customers" [value]="stockItems" filterMode="menu"
                [tableStyle]="{'min-width': '100%'}">

                <ng-template pTemplate="caption">
                  <div style="text-align: right">
                    <button type="button" pButton icon="pi pi-file-excel" iconPos="left" label="EXCEL"
                      (click)="exportExcel()" style="margin-right: 0.5em;" class="ui-button-success"></button>
                    <button type="button" pButton icon="pi pi-file-pdf" iconPos="left" label="PDF"
                      (click)="exportPdf()" class="ui-button-warning"></button>
                  </div>
                </ng-template>
                <ng-template pTemplate="header">
                  <tr>
                    <th width="1.5%">#</th>
                    <th pSortableColumn="customerName" style="min-width: 20%">Customer Name
                      <p-sortIcon field="customerName"></p-sortIcon>
                    </th>
                    <th pSortableColumn="productCategory" style="min-width: 25%">Product Category<p-sortIcon field="productCategory" /></th>
                    <th pSortableColumn="productType" style="min-width: 25%">Product Type<p-sortIcon field="productType" /></th>
                    <th pSortableColumn="productItem" style="min-width: 25%">Item Name<p-sortIcon field="productItem" /></th>
                    <th pSortableColumn="serialNumber" style="min-width: 10%">Serial Number <p-sortIcon field="serialNumber" /></th>
                    <th pSortableColumn="itemPurchaseDate" style="min-width: 25%">Coverage Start Date <p-sortIcon field="itemPurchaseDate" /></th>
                    <th pSortableColumn="itemExpiryDate" style="min-width: 25%">Coverage End Date <p-sortIcon field="itemExpiryDate" /></th>
                    <th pSortableColumn="status" style="min-width: 15%">Status <p-sortIcon field="status" /></th>
                    <th pSortableColumn="expiredAfter" style="min-width: 15%">Days to Expire<p-sortIcon field="expiredAfter"></p-sortIcon></th>
                    <th pSortableColumn="sbmStock" style="min-width: 15%">Sbm Stock<p-sortIcon field="sbmStock"></p-sortIcon></th>
                    <th pSortableColumn="absoluteItem" style="min-width: 15%">Obsolete<p-sortIcon field="absoluteItem"></p-sortIcon></th>
                    <th pSortableColumn="orderNumber" style="min-width: 25%">Order Number<p-sortIcon field="orderNumber" /></th>
                    <th pSortableColumn="costPrice" style="min-width: 25%">Cost Price <p-sortIcon field="costPrice" /></th>
                    <th pSortableColumn="sellingPrice" style="min-width: 25%">Selling Price <p-sortIcon field="sellingPrice" /></th>
                    <th style="width: 10rem">Actions</th>
                  </tr>
                  <tr>
                    <th></th>
                    <!-- Filter for Customer Name -->
                    <th>
                      <p-columnFilter field="customerName" matchMode="contains" placeholder="Filter by Customer" type="text" display="menu"></p-columnFilter>
                    </th>
                    <th>
                      <p-columnFilter field="productCategory" matchMode="contains" placeholder="Filter by Product Category" type="text" display="menu"></p-columnFilter>
                    </th>
                    <th>
                      <p-columnFilter field="productType" matchMode="contains" placeholder="Filter by Product Type" type="text" display="menu"></p-columnFilter>
                    </th>
                    <th>
                      <p-columnFilter field="productItem" matchMode="contains" placeholder="Filter by Item Name" type="text" display="menu"></p-columnFilter>
                    </th>
                    <th>
                      <p-columnFilter field="serialNumber" matchMode="contains" placeholder="Filter by Serial Number" type="text" display="menu"></p-columnFilter>
                    </th>
                    <th>
                      <p-columnFilter field="itemPurchaseDate" matchMode="dateIs" placeholder="Filter by Purchase Date" type="date" display="menu"></p-columnFilter>
                    </th>
                    <th>
                      <p-columnFilter field="itemExpiryDate" matchMode="dateIs" placeholder="Filter by Expiry Date" type="date" display="menu"></p-columnFilter>
                    </th>
                    <th>
                       <p-columnFilter
                          field="status"
                          display="menu"
                          matchMode="equals"
                          [showMatchModes]="false"
                          [showOperator]="false"
                          [showAddButton]="false"
                        >
                          <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                            <p-dropdown
                              [options]="['Active', 'Expired']"
                              [ngModel]="value"
                              (onChange)="filter($event.value)"
                              placeholder="Select Status"
                              [showClear]="true"
                            >
                            </p-dropdown>
                          </ng-template>
                        </p-columnFilter>
                    </th>
                    <th>
                      <p-columnFilter field="expiredAfter" matchMode="between" placeholder="Filter by Days" type="numeric" display="menu"></p-columnFilter>
                    </th>
                    <th>               
                      <p-columnFilter
                         field="sbmStock"
                          display="menu"
                          matchMode="equals"
                          [showMatchModes]="false"
                          [showOperator]="false"
                      >
                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                          <p-dropdown
                            [options]="[
                              { label: 'SBM Stock', value: true },
                              { label: 'Customer Stock', value: false }
                            ]"
                            [ngModel]="value"
                            (onChange)="filter($event.value)"
                            placeholder="Select Stock Type"
                            [showClear]="true"
                          >
                          </p-dropdown>
                        </ng-template>
                      </p-columnFilter>
                    </th>
                    <th>
                      <p-columnFilter type="boolean" field="absoluteItem" display="menu" placeholder="Obsolete"></p-columnFilter>
                    </th>
                    <th>
                      <p-columnFilter field="orderNumber" matchMode="contains" placeholder="Filter by Order Number" type="text" display="menu"></p-columnFilter>
                    </th>
                    <th>
                      <p-columnFilter field="costPrice" matchMode="equals" placeholder="Filter by Cost Price" type="numeric" display="menu"></p-columnFilter>
                    </th>
                    <th>
                      <p-columnFilter field="sellingPrice" matchMode="equals" placeholder="Filter by Selling Price" type="numeric" display="menu"></p-columnFilter>
                    </th>
                    <th></th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-stockItem>
                  <tr>
                    <td>{{ stockItems.indexOf(stockItem) + 1 }}</td>
                    <td>{{ stockItem.customerName ?? 'N/A' }}</td>
                    <td>{{ stockItem.productCategory ?? 'No Category' }}</td>
                    <td>{{ stockItem.productType ?? 'No Type' }}</td>
                    <td>{{ stockItem.productItem ?? 'No Item' }}</td>
                    <td>{{ stockItem.serialNumber ?? 'No Serial' }}</td>
                    <td>{{ stockItem.itemPurchaseDate | date }}</td>
                    <td>{{ stockItem.itemExpiryDate | date }}</td>
                    <td>
                      <span [ngStyle]="{
                        'color': (stockItem.expiredAfter !== null && stockItem.expiredAfter < 1) ? 'red' : 'green',
                        'font-weight': 'bold'
                      }">
                        {{ (stockItem.expiredAfter !== null && stockItem.expiredAfter < 1) ? 'Expired' : 'Active' }}
                      </span>
                    </td>
                    <td [ngStyle]="{
                      'color': stockItem.expiredAfter > 60 ? 'black' :
                               (stockItem.expiredAfter >= 31 ? 'orange' : 'red'),
                      'font-weight': 'bold'
                    }">{{ stockItem.expiredAfter }}</td>
                    <td>
                      <i
                        class="pi"
                        [ngClass]="{
                          'pi-check-circle text-green': stockItem.sbmStock,
                          'pi-times-circle text-red': !stockItem.sbmStock
                        }"
                      ></i>
                    </td>
                    <td>{{ stockItem.absoluteItem ? 'Yes' : 'No' }}</td>
                    <td>{{ stockItem.orderNumber ?? 'No Opportunity' }}</td>
                    <td>{{ stockItem.costPrice | currency }}</td>
                    <td>{{ stockItem.sellingPrice | currency }}</td>
                    <td>
                      <p-button icon="pi pi-eye" [rounded]="true" [outlined]="true" severity="info"
                        (onClick)="navigateToOrderItemsDetailsPage(stockItem)"></p-button>
                    </td>
                  </tr>
                </ng-template>

              </p-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <p-dialog header="Edit Stock Item" [(visible)]="editDialogVisible" [modal]="true" [closable]="false" [style]="{width: '50vw'}" *ngIf="selectedStockItem">
    <div class="p-fluid">
        <div class="form-group p-field p-grid row">
            <div class="col-md-12 col-xs-12">
                <label for="serialNumber">Serial Number</label>
                <input id="serialNumber" type="text" pInputText [(ngModel)]="selectedStockItem.serialNumber">
            </div>
        </div>
        <div class="form-group p-field p-grid row">
            <div class="col-md-6 col-xs-12">
                <label for="itemPurchaseDate">Start Coverage Date</label>
                <p-calendar id="itemPurchaseDate"  appendTo="body" [(ngModel)]="selectedStockItem.itemPurchaseDate" dateFormat="yy-mm-dd"></p-calendar>
            </div>
            <div class="col-md-6 col-xs-12">
                <label for="itemExpiryDate">Expiry Coverage Date</label>
                <p-calendar id="itemExpiryDate"  appendTo="body" [(ngModel)]="selectedStockItem.itemExpiryDate" dateFormat="yy-mm-dd"></p-calendar>
            </div>
        </div>
        <div class="form-group p-field p-grid row">
            <div class="col-md-6 col-xs-12">
                <label for="costPrice">Cost Price</label>
                <input id="costPrice" type="number" pInputText [(ngModel)]="selectedStockItem.costPrice">
            </div>
            <div class="col-md-6 col-xs-12">
                <label for="sellingPrice">Selling Price</label>
                <input id="sellingPrice" type="number" pInputText [(ngModel)]="selectedStockItem.sellingPrice">
            </div>
        </div>
    </div>
    <p-footer>
        <button class="p-button-text" type="button" pButton label="Cancel" icon="pi pi-times" (click)="closeEditDialog()"></button>
        <button type="button" pButton label="Save" icon="pi pi-check" (click)="saveStockItem()"></button>
    </p-footer>
</p-dialog>

</section>

<p-toast></p-toast>
